module.exports = __webpack_public_path__ + "img/Slice8-min.72b7d605.png";